import React, { FC } from 'react';
import { Card, CardBody, CardTitle, Col, Row } from 'reactstrap';
import { LinkButton, MaterialIcon, PageHeader, UserStateComponent } from '../../components';
import { useTranslation } from '../../translations';
import { Fetcher, isResourceError, useFetcher } from '../../utils';
import { getConventionIdParam } from './getConventionIdParam';

export const ConfirmComponent: FC<{
  readonly match: {
    params: {
      code?: string;
    };
  };
}> = ({ match }) => {
  const { ts } = useTranslation();
  return (
    <UserStateComponent>
      <PageHeader>{ts('account_registration')}</PageHeader>
      <Row className="justify-content-center">
        <Col lg={6} xs={12}>
          <Card>
            <CardBody className="text-center">
              <ConfirmInner code={match.params.code} />
              <hr />
              <LinkButton block color="link" to={`/login${getConventionIdParam()}`}>
                {ts('common.go_back_to_login')}
              </LinkButton>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </UserStateComponent>
  );
};

const ConfirmInner: FC<{ readonly code?: string }> = ({ code }) => {
  const { ts } = useTranslation();
  const fetcher = useFetcher(async () => {
    await api.confirmAccount(code ?? '');
  }, [code]);

  if (fetcher.error && isResourceError(fetcher.error, 'User')) {
    return (
      <div id="confirmError">
        <MaterialIcon className="mb-10" large name="warning" type="warning" />
        <CardTitle>{ts('error_during_activation')}</CardTitle>
        <p>{ts('sorry_but_the_code_you')}</p>
        <p>{ts('try_copying_the_activation_link')}</p>
      </div>
    );
  }

  if (fetcher.error) {
    return <Fetcher result={fetcher} />;
  }

  if (!fetcher.success) {
    return (
      <div id="confirmLoading">
        <MaterialIcon className="mb-10" large name="security" type="muted" />
        <CardTitle>{ts('just_a_moment')}</CardTitle>
        <p>{ts('were_trying_to_activate_your')}</p>
      </div>
    );
  }

  return (
    <div id="confirmActivated">
      <MaterialIcon className="mb-10" large name="verified_user" type="success" />
      <CardTitle>{ts('account_activated')}</CardTitle>
      <p>{ts('thanks_for_confirming_your_email')}</p>
      <p>{ts('your_account_is_active_and')}</p>
    </div>
  );
};
